import { Store } from 'repatch';
import State from '../core/State';
import OrderDirection from '../types/OrderDirection';
import { setOrder } from '../thunk/order';
import SalesByProductOrderTarget from '../types/SalesByProductOrderTarget';
import { setOrderBy } from '../thunk/orderBy';

class CreateTableUsecase {
  private store: Store<State>;

  constructor({ store }: { store: Store<State> }) {
    this.store = store;
  }

  public changeOrder = (order: OrderDirection) => {
    this.store.dispatch(setOrder(order));
  };

  public changeOrderBy = (orderBy: SalesByProductOrderTarget) => {
    this.store.dispatch(setOrderBy(orderBy));
  };
}

export default CreateTableUsecase;
